import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface ServicePlanBulkRetryConfirmData {
  count: number
}

@Component({
  selector: 'app-service-plan-bulk-retry-confirm-modal',
  templateUrl: './service-plan-bulk-retry-confirm-modal.component.html',
  styleUrls: ['./service-plan-bulk-retry-confirm-modal.component.scss'],
  standalone: false,
})
export class ServicePlanBulkRetryConfirmModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ServicePlanBulkRetryConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ServicePlanBulkRetryConfirmData,
  ) {}

  close(confirmed: boolean) {
    this.dialogRef.close(confirmed)
  }
}
